import React from 'react';
import cx from '../../../styles';
import { Icon } from '../Icon';

const AlertNotification = (props) => {
    return (
        <div className={cx(`notification-wrap ${props.modal? 'modal' : ''}`)}>
            <div className={cx('wrapper')}>
                <Icon name='alert-toast-regular'/>
                <p className={cx('message')}>{props.t('alert_acceptance_message')}</p>
            </div>
        </div>
    );
}

export default AlertNotification;